var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var TRACKS_ENDPOINTS = {
    ALL: "/Tracks",
};
/**
 * TracksApiClient - client for fetching tracks BFF endpoints
 * @export
 * @class TracksApiClient
 * @extends {BaseApiClient}
 */
var TracksApiClient = /** @class */ (function (_super) {
    __extends(TracksApiClient, _super);
    function TracksApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch all tracks from BFF
     * @throws {RequiredError}
     * @memberof TracksApiClient
     */
    TracksApiClient.prototype.getTracks = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(TRACKS_ENDPOINTS.ALL, fetchOptions);
    };
    return TracksApiClient;
}(BaseApiClient));
export { TracksApiClient };
//# sourceMappingURL=TracksApiClient.js.map